export const isWindowActive = () => !document.hidden
